export const disableActionsByDefaultModal = (columnId: string) => {
  return (
    columnId === 'periodo-id' ||
    columnId === 'venda-liquida-lastYear-id' ||
    columnId === 'venda-liquida-currentYear-id' ||
    columnId === 'porcentagem-venda-liquida-id' ||
    columnId === 'venda-liquida-btleo-lastYear-id' ||
    columnId === 'venda-liquida-btleo-currentYear-id' ||
    columnId === 'valor-venda-liquida-btleo-id' ||
    columnId === 'margem-lastYear-id' ||
    columnId === 'margem-currentYear-id' ||
    columnId === 'valor-margem-id' ||
    columnId === 'porcentagem-margem-lastYear-id' ||
    columnId === 'porcentagem-margem-currentYear-id' ||
    columnId === 'valor-porcentagem-margem-id'
  )
}
